import { OpenAI } from "langchain/llms/openai";
import { ConversationSummaryMemory } from "langchain/memory";
import { LLMChain } from "langchain/chains";
import { PromptTemplate } from "langchain/prompts";

const OPENAI_API_KEY =  process.env.REACT_APP_OPENAI_KEY  
const prompt2 = `You are an expert on whatever topic the human asks you. If you don't know the answer, make sure to say so. Current conversation:
{chat_history}
Human: {input}
AI:`;
var prompt_new =  prompt2;

const model = new OpenAI({
  openAIApiKey: OPENAI_API_KEY,
  modelName: "gpt-3.5-turbo",
  temperature: 0.5,
  streaming: true,
});

const memory = new ConversationSummaryMemory({
  memoryKey: "chat_history",
  llm: model,
});

let prompt = PromptTemplate.fromTemplate(prompt_new);
var chain = new LLMChain({
  llm: model,
  prompt,
  memory,
});

export let response = [];

export async function handler(input, reset, setData) {

  console.log("i am input", input)
  try {
    if (!OPENAI_API_KEY) {
      throw new Error("OPENAI_API_KEY is not defined.");
    }

    if (reset) {
      memory.clear();
    }

    const result = await chain.call(
      { input },
      [
        {
          handleLLMNewToken(token) {
            response.push(token);
            setData((prevResponses) => [...prevResponses, token]);
            // console.log(response)
          },
        },
      ]
    );

  } catch (error) {
    console.error(error);
  }
}

